import React from 'react';
import { usePopper } from 'react-popper';
import type { Placement } from '../config/get-config-popper';
import { getConfigPopper } from '../config/get-config-popper';

const useModalPosition = (boxRef: Element, placement?: Placement) => {
    const [referenceElement, setReferenceElement] =
        React.useState<HTMLElement | null>(null);
    const [popperElement, setPopperElement] =
        React.useState<HTMLElement | null>(null);

    const popper = usePopper(
        referenceElement,
        popperElement,
        getConfigPopper(boxRef, placement) as never,
    );

    return {
        setReferenceElement,
        setPopperElement,
        ...popper,
    };
};

export default useModalPosition;
